import React from "react";
import ReactCountryFlag from "react-country-flag";
import { CURRENCY_FLAG_OVERRIDES } from "../../../constants/enums";

interface CurrencySuffixProps {
  currency: string;
}

/**
 * Amount-input suffix: the card currency's flag (when it has an override, e.g.
 * USD → US, EUR → EU) followed by the currency code.
 */
const CurrencySuffix = ({ currency }: CurrencySuffixProps): React.ReactElement => {
  const flagCountry = CURRENCY_FLAG_OVERRIDES[currency];

  return (
    <span className="flex-row align-items-center">
      {flagCountry && (
        <ReactCountryFlag
          countryCode={flagCountry}
          className="emojiFlag flag"
          style={{
            fontSize: "24px",
            lineHeight: "24px",
          }}
          aria-hidden
        />
      )}
      <span className="text-primary ml-8">{currency}</span>
    </span>
  );
};

export default CurrencySuffix;